const themeClassSite: Record<Site, string> = {
  bitcasino: "bitcasino",
  livecasino: "livecasino",
  sportsbet: "sb",
};

const getThemeClassName = (site: Site, colorScheme: ColorScheme) =>
  `theme-${themeClassSite[site]}-${colorScheme}`;

export default getThemeClassName;
